<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <v-card>
      <v-data-table
        v-bind="schema.attributesTable.dataTable"
        v-model="selected"
        :headers="schema.headers"
        :items="schema.itemsTable"
        :search="search"
        :footer-props="{
          showFirstLastPage
        }"
      >
        <template v-slot:top v-if="schema.attributesTable.showToolbar">
          <v-toolbar flat>
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  data-has-tooltip="true"
                  data-tooltip="Exportar dados"
                  v-on="on"
                  v-bind="attrs"
                  icon
                  text
                  @click="openDialogExport()"
                  v-if="schema.attributesTable.showExport"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
              <span>Exportar dados</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-text-field
              v-if="schema.attributesTable.showSearch"
              v-model="search"
              append-icon="search"
              label="Pesquisar"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-card>

    <i4proDialogExport
      :dialog="showDialogExport"
      @closeDialogExport="closeDialogExport"
      :headers="schema.headers"
      :model="schema.itemsTable"
      :mode="formOptions.mode"
      :page="formOptions.page"
    />
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin],

  components: {
    i4proDialogExport: () => import('@/components/dialogs/i4pro-dialog-export')
  },

  data: () => ({
    search: '',
    showDialogExport: false,
    selected: []
  }),

  computed: {
    showFirstLastPage() {
      return this.schema.attributesTable.dataTable.showFirstLastPage;
    }
  },

  methods: {
    closeDialogExport() {
      this.showDialogExport = false;
    },

    openDialogExport() {
      this.showDialogExport = true;
    }
  },

  watch: {
    selected(newValue) {
      this.value = newValue;
    }
  }
};
</script>
